import api from "./api";

let providerCache = null;

export async function getProvidersAsync({ forceRefresh = false } = {}) {
  if (!forceRefresh && Array.isArray(providerCache)) {
    return providerCache;
  }

  const response = await api.get("/api/providers");
  providerCache = Array.isArray(response.data) ? response.data : [];
  return providerCache;
}

export function clearProvidersCache() {
  providerCache = null;
}
